module.exports = __webpack_public_path__ + "static/img/3921_phase_function_Paper_Points.b011985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3921_phase_function_Paper_Points.png
// module id = pb4n
// module chunks = 0